(() => {
  const selector = '.lb-video-proof';

  const playSilently = (video) => {
    video.muted = true;
    video.defaultMuted = true;
    video.loop = true;
    video.playsInline = true;
    video.play().catch(() => {});
  };

  const enhanceSection = (section) => {
    if (section.dataset.lbVideoAutoplayInitialized === 'true') return;

    const track = section.querySelector('.lb-video-proof__track');
    const videos = Array.from(section.querySelectorAll('.lb-video-proof__video'));
    if (!track || !videos.length) return;

    section.dataset.lbVideoAutoplayInitialized = 'true';

    videos.forEach((video) => {
      video.muted = true;
      video.defaultMuted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('autoplay', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
    });

    if (!section.querySelector('.lb-video-proof__swipe-hint')) {
      const hint = document.createElement('div');
      hint.className = 'lb-video-proof__swipe-hint';
      hint.setAttribute('aria-hidden', 'true');
      hint.innerHTML = [
        '<span class="lb-video-proof__swipe-hint-icon lb-video-proof__swipe-hint-icon--left">‹</span>',
        '<span>Desliza para ver más</span>',
        '<span class="lb-video-proof__swipe-hint-icon lb-video-proof__swipe-hint-icon--right">›</span>'
      ].join('');
      track.insertAdjacentElement('afterend', hint);
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting && entry.intersectionRatio >= 0.35) {
            playSilently(video);
          } else {
            video.pause();
          }
        });
      },
      { root: track, threshold: [0, 0.35, 0.7] }
    );

    videos.forEach((video) => observer.observe(video));

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        videos.forEach((video) => video.pause());
        return;
      }

      videos.forEach((video) => {
        const rect = video.getBoundingClientRect();
        const trackRect = track.getBoundingClientRect();
        if (rect.right > trackRect.left && rect.left < trackRect.right) playSilently(video);
      });
    });
  };

  const init = () => document.querySelectorAll(selector).forEach(enhanceSection);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
